<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >

      <div class="col-md-12">

        <div class="row d-flex m-0 p-0">

          <button type="button" class="btn btn-info border w-auto py-1 px-2 rounded-5 me-2">
            Clients sans commande <span class="badge bg-white text-black rounded-pill"> {{ clientSansVente }} </span>
          </button>

          <button type="button" class="btn btn-info border w-auto py-1 px-2 rounded-5">
            Clients débiteurs <span class="badge bg-white text-black rounded-pill"> {{ clientDebiteur }} </span>
          </button>

        </div>
        <hr class="mb-0">
    
        <div class="col-md-12 d-flex align-items-center justify-content-between mt-15 mt-sm-20 mt-md-25">

          <form class="search-box position-relative"  @submit.prevent="rechercher">
            <input
              type="text"
              v-model="searchTerm"
              @keyup="rechercher"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Rechercher un client"
            />
            <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>

          <div class="d-flex align-items-center justify-content-end flex-wrap">
            <a
              class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#AddElementModal"
            >
              <i class="flaticon-plus position-relative ms-5 fs-12"></i>
              Ajouter un client
          </a>
            
            <button
              class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
              type="button"
            >
              Export
              <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
            </button>
          </div>

        </div>

      </div>

      

      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  code
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  nom complet
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  téléphone
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Quatier
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  sexe
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cli, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ cli.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ cli.code }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ cli.nom +' '+ cli.prenoms }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ cli.telephone }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ cli.quartier }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ cli.sexe }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#AddElementModal"
                        @click="modification(cli)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(cli.id,elements,'client','ce client')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <AddClientModal :item="selectedItem"   @close="recharger"/>
  </template>
  

<script lang="ts">

  import { defineComponent, ref, onMounted } from 'vue';
  import { paginationFields } from '../Utilities/paginationFields';
  import { error, suppression } from '../../utils/utils';
  import ApiService from "../../services/ApiService";
  import  { Client }  from '../../models/Client';
  import AddClientModal from './AddClientModal.vue';
  import PaginationComponent from '@/components/Utilities/Pagination.vue';

  export default defineComponent({
    name: "ListeClient",
    components: {
      AddClientModal,
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<Client>>([])
      const selectedItem = ref(0);
      const element = ref<Client>();
        const clientSansVente = ref(0);
      const clientDebiteur = ref(0);

     
      function modification(item) {
        element.value = item;
        selectedItem.value = item.id;
      }

      // BEGIN PAGINATE
      const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };
     

      onMounted( async () => {
        await getAll();
        await fetchClientSansVente();
        await fetchClientDebiteur();
      })

      const fetchClientSansVente = async () => {
          try {
              // const response = await ApiService.get('/clients?limit=-1&');
              const response = await ApiService.get('/clientsWithoutOrder?limit=-1&');
              console.log('liste des clients sans commande',response.data.data);
              const data = response.data.data.totalElements;
              clientSansVente.value = data;
          } catch (error) {
              //
              console.log('error',error);
          }
      };

      const fetchClientDebiteur = async () => { 
          try {
              // const response = await ApiService.get('/clients?limit=-1&');
              const response = await ApiService.get('/clientsDebiteurs?limit=-1&');
              console.log('liste des clients débiteurs',response.data.data);
              const data = response.data.data.totalElements;
              clientDebiteur.value = data;
          } catch (error) {
              //
              console.log('error',error);
          }
      };


      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`clients?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('result', data.data.data);
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      return { 
        getAll,
        suppression,
        modification,
        elements,
        recharger,
        selectedItem,
        clientSansVente,
        clientDebiteur,
        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher
      };
    }

  });

</script>